import {
  useDraftListQuery,
  useLazyDraftListQuery
} from "@/src-refactor/modules/store/qrtk/services/property-draft/property-draft.qrtk";
import { useEffect, useRef } from "react";
import {
  CPropertyDraftListFilter,
  IPropertyDraftListFilterSchema,
  PropertyDraftListFilterSchema
} from "./util/propertyDraftListFilter";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import MxListObservableChange from "@rf-l1/page/list/MxListObservableChange";
import MxListLayoutMain from "@rf-l1/page/list/MxListLayoutMain";
import MxListLayoutBody from "@rf-l1/page/list/MxListLayoutBody";
import MxListCasesRenderTemplateTemplate from "@rf-l1/page/list/MxListingCasesRenderTemplate";
import MxListEmptyTemplate from "@rf-l1/page/list/MxlistEmptyTemplate";
import MxListErrorTemplate from "@rf-l1/page/list/MxlistErrorTemplate";
import propertyDraftListFilterAdapter from "../../adapters/propertyDraftListFilterAdapter";
import PropertyDraftMainFilters from "./components/PropertyDraftMainFilters";
import PropertyDraftListComponent from "./components/PropertyDraftListComponent";
import { Grid } from "@mui/material";
import { debounce } from "lodash";
import HCheckArray from "@rf-helper/check-have-value";
import { IDraftListResponse } from "@/src-refactor/modules/store/qrtk/services/property-draft/responses/draft-list.response";

function PropertyDraftListPage() {
  const form = useForm<IPropertyDraftListFilterSchema>({
    defaultValues: {
      ...CPropertyDraftListFilter
    },
    mode: "onChange",
    resolver: yupResolver(PropertyDraftListFilterSchema)
  });

  // Usar query en lugar de lazy query para cargar datos inicialmente
  const [GET_DRAFTS, GET_DRAFTS_DATA] = useLazyDraftListQuery({
    selectFromResult(state) {
      const values = form.getValues();
      const typeDraft = HCheckArray(values.typeDraft)
        ? values.typeDraft[0].id
        : undefined;

      if (typeDraft || typeDraft === 0) {
        return {
          ...state,
          data: {
            data: state.data?.data.filter(item => item.is_project === typeDraft)
          }
        };
      } else {
        return {
          ...state,
          data: state.data
        };
      }
    }
  });

  const handleUpdateFilters = debounce((data: IPropertyDraftListFilterSchema) => {
    GET_DRAFTS({
      query: propertyDraftListFilterAdapter(data)
    })
      .unwrap()
      .then(() => {
        const element = document.getElementById("scroll-to-top");
        if (element) {
          element.scrollIntoView();
        }
      });
  }, 300);

  // Cargar datos iniciales
  useEffect(() => {
    const initialData = form.getValues();
    handleUpdateFilters(initialData);
    return () => {
      handleUpdateFilters.cancel();
    };
  }, []);

  return (
    <FormProvider {...form}>
      <MxListObservableChange handleOnChangeFilter={handleUpdateFilters} />
      <MxListLayoutMain justifyContent={"flex-start"}>
        <Grid container item xs={12} id="scroll-to-top"></Grid>

        <PropertyDraftMainFilters total={GET_DRAFTS_DATA.data?.data?.length || 0} />

        <MxListLayoutBody my={1}>
          <MxListCasesRenderTemplateTemplate
            minHeight="50vh"
            emptyComponent={
              <MxListEmptyTemplate
                variant="empty"
                // title="¡Sin borradores!"
                // description="No se encontraron borradores "
              />
            }
            errorComponent={<MxListErrorTemplate />}
            hasError={GET_DRAFTS_DATA.isError}
            isLoading={GET_DRAFTS_DATA.status === "pending"}
            isEmpty={!GET_DRAFTS_DATA.data?.data?.length}
            listComponent={
              <PropertyDraftListComponent
                data={GET_DRAFTS_DATA.data as IDraftListResponse}
              />
            }
            paginationComponent={<></>}
          />
        </MxListLayoutBody>
      </MxListLayoutMain>
    </FormProvider>
  );
}

export default PropertyDraftListPage;
